<template lang="html">
    <div class="freight-card" v-loader-overlay="progressFreight">
        <router-link v-if="!$props.hideLink" v-bind:to="{ name: 'Freights', query: {search: freight.traking_number} }">Перейти к грузу</router-link>
        <div v-if="freight && freight.full_price && freight.full_price.storage">
            <span>{{ 'Стоимость хранения груза в пункте выдачи: ' + freight.full_price.storage + ' р.' }}</span>
        </div>

        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
                <z-input
                    name="freight_seats_number" id="freight_seats_number" label="Количество мест" 
                    type="number" required v-model="freight.seats_number"
                    v-bind:disabled="$props.block"
                    data-vv-as=" " v-validate="'required'" v-bind:error="errors.first('freight_seats_number')"
                    inline
                ></z-input>
                <z-input
                    name="freight_weight"  id="freight_weight"  label="Вес (кг)" type="number"
                    v-model="freight.weight"  required
                    v-bind:disabled="$props.block"
                    data-vv-as=" "
                    v-validate="{required: true, min_value: 0, max_value: 99999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_weight')"
                    inline
                ></z-input>
                <z-check
                    label="Оформление ТТН"
                    id="freight_ttn"
                    v-model="ttn"
                    v-bind:value="true"
                    v-bind:error="errors.first('freight_ttn')"
                    data-vv-name="freight_ttn"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="true"
                    inline
                ></z-check>
                <z-check
                    v-show="freight.weight > 0 && freight.size > 0"
                    label="Обрешётка"
                    id="freight_doom"
                    v-model="freight.doom"
                    v-bind:value="1"
                    v-bind:disabled="$props.block"
                    v-bind:error="errors.first('freight_doom')"
                    data-vv-name="freight_doom"
                    v-bind:data-vv-as="' '"
                    inline
                ></z-check>
                <z-check
                    v-if="freight.extraservices && freight.extraservices.doom_make"
                    v-show="freight.weight > 0 && freight.size > 0"
                    label="Изготовление обрешётки"
                    id="freight_doom_make"
                    v-model="freight.extraservices.doom_make.value.value"
                    v-bind:value="1"
                    v-bind:error="errors.first('freight_doom_make')"
                    data-vv-name="freight_doom_make"
                    v-bind:data-vv-as="' '"
                    :disabled="true"
                    inline
                ></z-check>
                <z-check
                    v-show="freight.weight > 0 && freight.size > 0"
                    label="Негабаритный груз"
                    id="oversize"
                    v-model="freight.oversize"
                    v-bind:value="1"
                    v-bind:error="errors.first('oversize')"
                    data-vv-name="oversize"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="$props.block || (!!freight.full_oversize)"
                    inline
                ></z-check>
                <div class="full_oversize error" v-if="(fullOversizeMessage)" v-html="fullOversizeMessage"></div>
            </div>

            <div class="md-layout-item md-size-50">
                <z-input
                    name="freight_height" id="freight_height" label="Высота (м)" 
                    v-model="freight.height" required type="number"
                    v-bind:disabled="$props.block"
                    data-vv-as=" "
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_height')"
                    inline
                ></z-input>

                <z-input
                    name="freight_length" id="freight_length" label="Длина (м)"
                    v-model="freight.length" required type="number"
                    v-bind:disabled="$props.block"
                    data-vv-as=" "
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_length')"
                    inline
                ></z-input>

                <z-input
                    name="freight_width" id="freight_width" label="Ширина (м)"
                    v-model="freight.width" required type="number"
                    v-bind:disabled="$props.block"
                    data-vv-as=" "
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_width')"
                    inline
                ></z-input>

                <z-input
                    name="freight_size" id="freight_size" label="Объем (м^3)" 
                    v-model="freight.size" required type="number"
                    data-vv-as=" "
                    v-bind:disabled="($props.block || (!!computedVolume && computedVolume > 0))"
                    v-validate="{required: true, min_value: 0.001, max_value: 99999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_size')"
                    inline
                ></z-input>
            </div>

            <div class="md-layout-item md-size-50">
                <z-input
                    v-if="parseInt(freight.oversize) === 1"
                    name="oversize_weight"  id="oversize_weight" label="Вес негабарита (кг)" type="number"
                    v-model="freight.oversize_weight" required
                    data-vv-as=" " 
                    v-validate="{required: !!freight.oversize, decimal: true, min_value: 0.001, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.weight ? parseFloat(freight.weight) : 0))}"
                    v-bind:error="errors.first('oversize_weight')"
                    v-bind:disabled="$props.block || (!!freight.full_oversize)"
                    inline
                ></z-input>
                
                <z-input
                    v-if="parseInt(freight.oversize) === 1"
                    name="oversize_size" id="oversize_size" label="Объем негабарита (м^3)" type="number"
                    v-model="freight.oversize_size" required
                    data-vv-as=" " 
                    v-validate="{required: !!freight.oversize, decimal: true, min_value: 0.001, max_value:  ((!!freight.full_oversize) ? 9999999999 : (freight.size ? parseFloat(freight.size) : 0))}"
                    v-bind:error="errors.first('oversize_size')"
                    v-bind:disabled="$props.block || (!!freight.full_oversize)"
                    inline
                ></z-input>

                <z-input
                    v-if="(parseInt(freight.oversize) ? true : false)"
                    label="Сумма сторон (м)"
                    v-model="computedSumValue"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_oversize_sum"
                    id="freight_oversize_sum"
                    type="number"
                    data-vv-name="freight_oversize_sum"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="true"
                    inline
                ></z-input>
            </div>

            <div class="md-layout-item md-size-50">
                <z-input
                    v-if="(!hasDoom && parseInt(freight.oversize) && freight.height > 0 ? true : false)"
                    label="Высота негабарита (м)"
                    v-model="freight.oversize_height"
                    :select-on-focus="true"
                    name="freight_oversize_height"
                    id="freight_oversize_height"
                    v-validate="{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.height ? parseFloat(freight.height) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_height')"
                    data-vv-name="freight_oversize_height"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                ></z-input>

                <z-input
                    v-if="(!hasDoom && parseInt(freight.oversize) && freight.length > 0 ? true : false)"
                    label="Длина негабарита (м)"
                    v-model="freight.oversize_length"
                    :select-on-focus="true"
                    name="freight_oversize_length"
                    id="freight_oversize_length"
                    v-validate="{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.length ? parseFloat(freight.length) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_length')"
                    data-vv-name="freight_oversize_length"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                ></z-input>

                <z-input
                    v-if="(!hasDoom && parseInt(freight.oversize) && freight.width > 0 ? true : false)"
                    label="Ширина негабарита (м)"
                    v-model="freight.oversize_width"
                    :select-on-focus="true"
                    name="freight_oversize_width"
                    id="freight_oversize_width"
                    v-validate="{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.width ? parseFloat(freight.width) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_width')"
                    data-vv-name="freight_oversize_width"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                ></z-input>
            </div>

            <div class="md-layout-item md-size-100">
                <z-input
                    name="freight_description" id="freight_description" label="Наименование груза"
                    v-model="freight.description" required v-bind:disabled="$props.block"
                    data-vv-as=" " v-validate="'required|min:1|max:100'" v-bind:error="errors.first('freight_description')"
                ></z-input>
            </div>
        </div>
    </div>
</template>
<script>
import Properties from '@/components/Properties';
import Services from '@/components/Services';
import moment from "moment";
import ZInput from '@/components/ZInput';
import ZSelect from '@/components/ZSelect';
import ZCheck from '@/components/ZCheck';
export default {
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        index: {
            type: [Number, String],
            default: () => 'freight-new'
        },
        hideLink: {
            type: Boolean,
            default: false
        },
        statuses: {
            type: Array,
            default: () => []
        },
        recipient_id: {
            type: Number,
            default: 0
        },
        block: {
            type: Boolean,
            default: false
        }
    },
    components: { Properties, Services, ZInput, ZSelect, ZCheck },
    data() {
        return {
            ttn: true,
            status: {},
            freight: {},
            OversizeType: [],
            computedSumValue: 0,
            fullOversizeMessage: '',
            form: {
                freight_id:     null,
                status_id:      null,
                stock_id:       null,
                responsible_id: null,
                date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            }
        }
    },
    name: 'freight-card',
    created() {
        this.freight = Object.assign({}, this.$props.value);
        this.setDefaultTrackingStatus();
        this.$validator.localize('ru', {
            attributes: {
                freight_description: 'наименование',
                freight_seats_number: 'кол-во мест',
                freight_weight: 'вес',
                freight_size: 'объем',
                freight_departure_date: 'дата забора',
                oversize: 'Является негабаритом',
                oversize_weight: 'Вес негабарита',
                oversize_size: 'Объём негабарита',
            }
        });
    },
    computed: {
        progressFreight() {
            return this.progressObj['load-freight-card'];
        },
        progressObj() {
            return this.$store.state.progressObj;
        },
        user() {
            if (!this.$store.state.users.current || !this.$store.state.users.current.id) return;
            return this.$store.state.users.current;
        },
        computedVolume() {
            if (!this.freight.height || !this.freight.length || !this.freight.width) return;
            return (this.freight.height * this.freight.length * this.freight.width).toFixed(3) + 0;
        },
        computedSum() {
            if (
                !this.freight.height || !this.freight.length || !this.freight.width ||
                this.freight.height <= 0 || this.freight.length <= 0 || this.freight.width <= 0
            ) return 0;
            return parseFloat(parseFloat(this.freight.height) + parseFloat(this.freight.length) + parseFloat(this.freight.width)).toFixed(3);
        },
        hasDoom() {
            return (!this.freight || !this.freight.doom || parseInt(this.freight.doom) == 0) ? false : true;
        },
        readyToCheckOversize() {
            return (this.freight.size > 0 && this.freight.weight > 0) ? true : false;
        }
    },
    methods: {
        validate() {
            return this.$validator.validateAll();
        },
        changeService() {
            this.$emit('change', this.freight);
        },
        setDefaultTrackingStatus() {
            if (!this.$props.statuses || !this.$props.statuses.length) return;
            let status = this.$props.statuses.find((item, i) => item.code === 'storekeeper_issued_to_client');
            this.status = Object.assign({}, status);
            this.form.status_id = this.status.id;
        },
        issue() {
            this.loading = true;
            this.form.freight_id = this.$props.value.id;
            this.form.stock_id = this.$props.value.currenttracking.stock_id;
            this.form.responsible_id = this.user.id;
            this.$store.dispatch('stock/addFreightTracking', this.form).then(r => {
                this.$store.commit('showSnackbar', ['Груз успешно выдан получателю', 6000, 'success']);
                this.$emit('reload');
                return r;
            }).finally(() => this.loading = false);
        },
        getOversizeLabel(types) {
            let type = types.find(item => !!item);
            switch (type) {
                case 'sum':    return 'сумме сторон';
                case 'weight': return 'весу';
                case 'size':   return 'объёму';
                case 'volume': return 'объёму';
                case 'height': return 'высоте';
                case 'length': return 'длине';
                case 'width':  return 'ширине';
            }
        },
        checkOversize() {
            this.$store.commit('showProgressBar', 'load-freight-card');
            let freight = Object.assign({}, this.freight);
            freight.oversize_weight = 0;
            freight.oversize_size   = 0;
            freight.oversize_height = 0;
            freight.oversize_length = 0;
            freight.oversize_width  = 0;
            freight.full_oversize   = 0;
            return this.$store.dispatch('deals/checkFreightOversize', {deal: this.freight.deal, freight: freight, freight_id: this.freight.id}).then(r => {
                if (r && r.oversize) {
                    if (r.oversize_type) this.OversizeType = Object.assign([], r.oversize_type);
                    this.fullOversizeMessage = (r.oversize_type && r.oversize_type.length) ? 'Груз является негабаритом по <b>' + this.getOversizeLabel(r.oversize_type) + '</b>' : 'Груз является негабаритом'; 
                    if (r.full_oversize) {
                        this.fullOversizeMessage = (r.oversize_type && r.oversize_type.length) 
                            ? 'Груз является полным негабаритом по <b>' + this.getOversizeLabel(r.oversize_type) + '</b>, изменение параметров невозможно.'
                            : 'Груз является полным негабаритом, изменение параметров невозможно.'; 
                    }
                    /*this.freight.oversize      = (r.oversize) ? 1 : 0;
                    this.freight.full_oversize   = (r.full_oversize) ? 1 : 0;
                    this.freight.oversize_weight = r.oversize_weight;
                    this.freight.oversize_size   = r.oversize_volume;
                    this.freight.oversize_height = r.oversize_height;
                    this.freight.oversize_length = r.oversize_length;
                    this.freight.oversize_width  = r.oversize_width;*/
                } else {
                    /*this.OversizeType = [];
                    //this.freight.oversize      = 0;
                    this.freight.full_oversize   = 0;
                    this.freight.oversize_weight = 0;
                    this.freight.oversize_size   = 0;
                    this.freight.oversize_height = 0;
                    this.freight.oversize_length = 0;
                    this.freight.oversize_width  = 0;*/
                    this.fullOversizeMessage     = null;
                }
                
            }).finally(() => this.$store.commit('hideProgressBar', 'load-freight-card'));
        },
    },
    watch: {
        '$props.value': {
            handler(freight) {
                //this.$emit('change', val);
                if (JSON.stringify(freight) != JSON.stringify(this.freight)) this.freight = Object.assign({}, freight);
            },
            deep: true
        },
        'freight': {
            handler(freight) {
                this.$emit('change', freight);
                this.$emit('input', freight);
            },
            deep: true
        },
        '$props.statuses'() {
            this.setDefaultTrackingStatus();
        },
        'freight.oversize'(value) {
            if (this.readyToCheckOversize) this.checkOversize();
        },
        'freight.doom'(doom) {
            if (parseInt(this.freight.doom) === 1) this.freight.extraservices.doom_make.value.value = true;
            if (parseInt(this.freight.doom) === 0) this.freight.extraservices.doom_make.value.value = false;
            if (this.readyToCheckOversize) this.checkOversize();
        },
        'freight.size'(value) {
            setTimeout(() => {if (this.readyToCheckOversize && this.freight.oversize && value == this.freight.size) this.checkOversize();}, 1000);
        },
        'freight.weight'(value) {
            setTimeout(() => {if (this.readyToCheckOversize && this.freight.oversize && value == this.freight.weight) this.checkOversize();}, 1000);
        },
        'computedSum'(value) {
            this.computedSumValue = parseFloat(value).toFixed(3);
            setTimeout(() => {if (this.readyToCheckOversize && this.freight.oversize && value == this.computedSumValue) this.checkOversize();}, 1000);
        },
        'computedVolume'(value) {
            if (value > 0) this.freight.size = value;
        },
    }
}
</script>
<style lang="sass">
    .cart-head
        display: flex
        align-items: center
        justify-content: space-between
        .cart-head-item
            margin: 0
</style>



// WEBPACK FOOTER //
// FreightCard.vue?208f7c8f